'use strict';

/**
 * DYOJ Category Page - Load more (20 tiles per request)
 */

module.exports = {
    init: function () {
        $('body').on('click', '.dyoj-show-more button.more', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $button = $(this);
            var url = $button.data('url');
            var cgid = $button.data('cgid');
            var start = parseInt($button.data('start'), 10) || 0;
            var pageSize = parseInt($button.data('page-size'), 10) || 24;

            if (!url || !cgid) {
                return;
            }

            $.spinner().start();

            $.ajax({
                url: url,
                method: 'GET',
                data: {
                    cgid: cgid,
                    start: start,
                    sz: pageSize
                },
                success: function (response) {
                    var html = response;
                    if (!html) {
                        $button.closest('.dyoj-show-more').remove();
                        $.spinner().stop();
                        return;
                    }

                    var $temp = $('<div>').append($.parseHTML(html, document, true));
                    var addedCount = $temp.find('.product-tile-wrapper').length;

                    $('.dyoj-category-page .product-grid').append(html);

                    var nextStart = start + pageSize;
                    $button.data('start', nextStart);
                    $button.attr('data-start', nextStart);

                    if (addedCount < pageSize) {
                        $button.closest('.dyoj-show-more').remove();
                    }

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }
};
